import {
  SVG,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Box, Text, View} from 'native-base';
import React, {ReactElement} from 'react';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';
import {useTheme} from 'styled-components/native';

interface IconSizeTypes {
  height: number;
  width: number;
}

interface ErrorDisplayPropTypes {
  isSVG: boolean;
  iconName: string;
  iconColor?: string;
  iconIsLight?: boolean;
  iconSize: IconSizeTypes;
  titleText: string;
  upperDescriptionText: string;
  lowerDescriptionText?: ReactElement | string;
  children?: ReactElement | undefined;
  hasFooter?: boolean;
}

const ErrorDisplay: React.FC<ErrorDisplayPropTypes> = ({
  isSVG,
  iconName,
  iconColor,
  iconIsLight,
  iconSize,
  titleText,
  upperDescriptionText,
  lowerDescriptionText,
  children,
  hasFooter = false,
}) => {
  const theme = useTheme();
  const {white, tuna} = theme.colors;
  const isDesktop = useIsDesktop();

  const renderDescription = (
    description: string | ReactElement | undefined
  ) => {
    if (description === undefined || description === '') {
      return null;
    }

    if (typeof description === 'string') {
      return (
        <Text
          px={5}
          textAlign="center"
          fontFamily="body"
          fontSize={isDesktop ? '18px' : '14px'}
          lineHeight={isDesktop ? '30px' : '20px'}
          color={tuna}>
          {description}
        </Text>
      );
    }

    return description;
  };

  return (
    <View
      justifyContent="center"
      alignItems="center"
      backgroundColor={white}
      overflow="hidden"
      flex={1}
      maxWidth={isDesktop ? '1018px' : '100%'}
      minHeight={isDesktop ? (hasFooter ? '442px' : '662px') : '343px'}
      borderRadius="4px"
      px="8px"
      shadow={!hasFooter ? 0 : undefined}>
      <Box justifyContent="center" alignItems="center">
        {isSVG ? (
          <SVG
            source={iconName}
            width={iconSize.width}
            height={iconSize.height}
            alt={''}
          />
        ) : (
          <Icon
            name={iconName}
            color={iconColor}
            size={iconSize.width}
            light={iconIsLight}
          />
        )}
        <Text
          textAlign="center"
          fontFamily="heading"
          fontWeight="700"
          fontSize={isDesktop ? '36px' : '22px'}
          lineHeight={isDesktop ? '39px' : '24px'}
          width={isDesktop ? '800px' : null}
          mt="24px"
          mb="16px"
          mx="24px"
          color={tuna}
          textTransform="uppercase">
          {titleText}
        </Text>
        {renderDescription(upperDescriptionText)}
        {renderDescription(lowerDescriptionText)}
        {children}
      </Box>
    </View>
  );
};

export default ErrorDisplay;
